import React from 'react';
import { css } from 'styled-components';
import i18n from 'i18n';
import CustomMedia from 'util/custom-media-query';
import Jump from 'components/common/Jump';
import Content from './components/Content';
import Duration from './components/Duration';
import { applyStyles } from 'util/helpers';
import Breadcrumbs from 'components/common/Breadcrumbs';
import GrayHeader from 'components/common/GrayHeader';

const aboutDelivery = ({ className, location: { pathname } }) => (
  <div className={className}>
    <GrayHeader text={i18n.t('about:delivery.grayHeader')} />
    <Breadcrumbs currentPath={pathname} />
    <Jump />
    <section className="content">
      <Content />
    </section>
    <section>
      <Duration />
    </section>
  </div>
);

const commonStyle = css``;

const pcStyle = CustomMedia.greaterThan('umedium')`
  max-width: 886px;
  margin: 0 auto;

  ${Breadcrumbs} {
    margin-top: 12px;
  }

  section {
    padding: 40px 0;

    &:last-child {
      padding: 0 0 160px 0;
    }
  }

  section.content {
    padding-top: 0px;
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  margin: 0 16px;

  ${Breadcrumbs} {
    margin-top: 6px;
  }

  section {
    padding: 32px 0;

    &:last-child {
      padding: 0 0 48px 0;
    }
  }

  section.content {
    padding-top: 0px;
  }
`;

export default applyStyles(aboutDelivery)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/About/Delivery/index.js